import { getFontCss as d } from "./font-utils.mjs";
import { ROOT_DESIGN_ID as i, ROOT_FONT_ID as m } from "../constants/root-theme-id.mjs";
import { getRootDesignCss as l } from "./get-root-design-css.mjs";
const f = (t, p) => {
  const e = p ?? document, c = l(t), o = e.createElement("style");
  o.id = i;
  const s = e.getElementById(i);
  s && s.remove(), o.append(c), e.head.append(o);
  const a = d(t.primaryFont, t.secondaryFont), n = e.createElement("style");
  n.id = m;
  const r = e.getElementById(m);
  r && r.remove(), n.append(a), e.head.append(n);
};
export {
  f as applyDesign
};
